export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /home/jenkins/hydrogen/workspace/Release_Engineering/Artifactory-Release-Packagers/Builders/Conduit-Release/consent/src/environments/environment.ts